import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Reveal } from "@/components/Reveal";
import { BlogCard } from "@/components/blog/BlogCard";
import { getBlogList } from "@/lib/api";

export const BlogPreview = () => {
  const { data } = useQuery({ queryKey: ["blog", "preview"], queryFn: () => getBlogList({ limit: 6 }) });
  const posts = (data && data.items) || [];
  if (!posts.length) return null;

  return (
    <section className="section-pad bg-[#141517]" data-testid="home-blog-preview">
      <div className="container-lux">
        <Reveal>
          <div className="flex flex-wrap items-end justify-between gap-4">
            <div className="max-w-2xl">
              <span className="eyebrow">Blog & Rehberler</span>
              <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-[#F7F2E8] mt-3">
                Düğün fotoğrafçılığı rehberi
              </h2>
              <p className="text-[#9A9387] mt-3">
                Fotoğrafçı seçimi, fiyatlar, çekim günü planı ve Ankara'nın 25 ilçesi için mekân rehberleri.
              </p>
            </div>
            <Link to="/blog" data-testid="home-blog-all-link">
              <Button variant="outline" className="border-white/20 text-[#F7F2E8] bg-transparent hover:bg-white/5">
                Tüm Yazılar <ArrowRight className="w-4 h-4 ml-2" />
              </Button>
            </Link>
          </div>
        </Reveal>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-12">
          {posts.map((p, i) => (
            <Reveal key={p.slug} delay={i * 0.06}>
              <BlogCard post={p} surface="bg-[#1A1B1E]" />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogPreview;
